module.exports = __webpack_public_path__ + "static/worldlinetechforum-b18ad1eb9ca5b387937500533940922c.png";